// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.kebijakan-privasi {
    text-align: justify;
}
.kebijakan-privasi h3, .kebijakan-privasi h4, .kebijakan-privasi h5 {
    margin-top: 0;
    margin-bottom: 15px;
    font-weight: 600;
}
.kebijakan-privasi h5 {
    text-decoration: underline;
}
.kebijakan-privasi span {
    font-weight: 600;
}
.kebijakan-text-color {
    color: black;
    font-weight: 400;
}
.kebijakan-list {
    margin: 10px 0;
    list-style: none;
    padding-left: 0;
}
.kebijakan-list li {
    margin: 2px 0;
}`, "",{"version":3,"sources":["webpack://./src/assets/css/kebijakan.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,gBAAgB;AACpB;AACA;IACI,0BAA0B;AAC9B;AACA;IACI,gBAAgB;AACpB;AACA;IACI,YAAY;IACZ,gBAAgB;AACpB;AACA;IACI,cAAc;IACd,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI,aAAa;AACjB","sourcesContent":[".kebijakan-privasi {\r\n    text-align: justify;\r\n}\r\n.kebijakan-privasi h3, .kebijakan-privasi h4, .kebijakan-privasi h5 {\r\n    margin-top: 0;\r\n    margin-bottom: 15px;\r\n    font-weight: 600;\r\n}\r\n.kebijakan-privasi h5 {\r\n    text-decoration: underline;\r\n}\r\n.kebijakan-privasi span {\r\n    font-weight: 600;\r\n}\r\n.kebijakan-text-color {\r\n    color: black;\r\n    font-weight: 400;\r\n}\r\n.kebijakan-list {\r\n    margin: 10px 0;\r\n    list-style: none;\r\n    padding-left: 0;\r\n}\r\n.kebijakan-list li {\r\n    margin: 2px 0;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
